module.exports = __webpack_public_path__ + "static/media/foodpartners_bb_mobile.c6781360.png";